<template>
  <div v-if="!short">
    <div class="d-flex align-items-center">
      <b-icon icon="circle-fill" scale="1.3" :style="circleStyle" />
      <div class="pl-2">
        {{ statusName }}
      </div>
      <span v-if="errorCount > 0" class="ml-3"> ({{ errorCount }} {{ pluralize('error', errorCount) }}) </span>
    </div>
  </div>
  <div v-else>
    <BaseLabel :id="labelId" :short-text="statusShortName" :tooltip-text="statusName" :color="labelColor" />
  </div>
</template>

<script lang="ts">
import type { Assignment } from '@/types/Models/Assignment'
import { defineComponent, computed, type PropType, type ComputedRef } from 'vue'
import { useAssignmentStatus } from '@/composables/Assignment/useAssignmentStatus'
import { pluralize } from '@/services/Helpers'
import BIcon from '@/views/Components/Elements/Icons/BIcon.vue'
import BaseLabel from '@/views/Components/Labels/BaseLabel.vue'

export default defineComponent({
  name: 'AssignmentStatus',
  components: { BIcon, BaseLabel },
  props: {
    assignment: {
      type: Object as PropType<Assignment>,
      required: true,
    },
    short: {
      type: Boolean,
      required: false,
      default: false,
    },
    errorCount: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  setup(props) {
    const assignment: ComputedRef<Assignment> = computed(() => props.assignment)

    const { statusName, statusShortName, circleStyle } = useAssignmentStatus(assignment)

    const labelId: ComputedRef<string> = computed(() => `assignment-type-${assignment.value.id}`)
    const labelColor: ComputedRef<string> = computed(() => circleStyle.value.color)

    return {
      labelId,
      labelColor,
      statusName,
      statusShortName,
      circleStyle,
      pluralize,
    }
  },
})
</script>
